import React, { FC, useMemo } from "react";
import { AccountLeadsFiltersStore } from "../../../../../../../store/UserAccounts/UserAccount/AccountLeads/AccountLeadsFilters.store";
import { observer } from "mobx-react";
import { LeadFilterHeaderCell } from "./LeadFilterHeaderCell";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/pro-solid-svg-icons";
import { LEAD_FILTER_ICON_SIZE } from "../../../../../../../constants/lead-filter-icon-size";
import { LeadSimpleFilterTypes } from "../../../../../../../enums/leads-simple-filter-type.enum";
import { LeadFilterSimpleCombinedMenu } from "./LeadFilterMenu/LeadFilterCombinedMenu";
import { sortBy } from "lodash";

const availableOptionTitles: Partial<Record<LeadSimpleFilterTypes, string>> = {
  [LeadSimpleFilterTypes.REFERRED_BY_ACCOUNT]: "Referred By Account",
  [LeadSimpleFilterTypes.REFERRED_BY_OFFICE]: "Referred By Office",
};

interface IProps {
  leadsFilterStore: AccountLeadsFiltersStore;
}

export const FilterLeadsReferredByHeader: FC<IProps> = observer(
  ({ leadsFilterStore }) => {
    const { activeFilter, availableFilters, pendingFilter } = leadsFilterStore;

    const referredByOptions = useMemo(() => {
      if (
        !availableFilters ||
        !availableFilters.referredByAccount ||
        !availableFilters.referredByOffice
      )
        return {};

      return {
        [LeadSimpleFilterTypes.REFERRED_BY_ACCOUNT]: sortBy(
          availableFilters.referredByAccount,
          account => account.label?.toLowerCase()
        ).map(account => ({
          value: account.id,
          label: account.label,
          count: account.count,
        })),
        [LeadSimpleFilterTypes.REFERRED_BY_OFFICE]: sortBy(
          availableFilters.referredByOffice,
          office => office.label?.toLowerCase()
        ).map(office => ({
          value: office.id,
          label: office.label,
          count: office.count,
        })),
      };
    }, [availableFilters]);

    return (
      <LeadFilterHeaderCell title={"Referred By"}>
        <LeadFilterSimpleCombinedMenu
          leadsFilterStore={leadsFilterStore}
          icon={
            <FontAwesomeIcon icon={faFilter} fontSize={LEAD_FILTER_ICON_SIZE} />
          }
          filterTypes={[
            LeadSimpleFilterTypes.REFERRED_BY_ACCOUNT,
            LeadSimpleFilterTypes.REFERRED_BY_OFFICE,
          ]}
          availableOptions={referredByOptions}
          availableOptionLabels={availableOptionTitles}
          selectedOptions={{
            [LeadSimpleFilterTypes.REFERRED_BY_ACCOUNT]:
              pendingFilter[LeadSimpleFilterTypes.REFERRED_BY_ACCOUNT],
            [LeadSimpleFilterTypes.REFERRED_BY_OFFICE]:
              pendingFilter[LeadSimpleFilterTypes.REFERRED_BY_OFFICE],
          }}
          appliedOptions={
            !!activeFilter
              ? {
                  [LeadSimpleFilterTypes.REFERRED_BY_ACCOUNT]:
                    activeFilter[LeadSimpleFilterTypes.REFERRED_BY_ACCOUNT],
                  [LeadSimpleFilterTypes.REFERRED_BY_OFFICE]:
                    activeFilter[LeadSimpleFilterTypes.REFERRED_BY_OFFICE],
                }
              : {
                  [LeadSimpleFilterTypes.REFERRED_BY_ACCOUNT]: [],
                  [LeadSimpleFilterTypes.REFERRED_BY_OFFICE]: [],
                }
          }
        />
      </LeadFilterHeaderCell>
    );
  }
);
